module.exports = __webpack_public_path__ + "static/media/GemR.2b96ebc3.png";